import { Component, HostListener, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { RfidFormComponent } from '../../components/rfid-form/rfid-form.component';
import { LoginFormComponent } from '../../components/login-form/login-form.component';

import { LOGIN_WIDTH_CHANGE_PLACEMENT } from 'src/app/core/constants/components';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: true,
    imports: [
    LoginFormComponent,
    RfidFormComponent
],
})
export class LoginComponent implements OnInit {
    showRFID: boolean = true;
    environment: any;
    innerWidth: number = 0;
    LOGIN_WIDTH_CHANGE_PLACEMENT = LOGIN_WIDTH_CHANGE_PLACEMENT;

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.innerWidth = window.innerWidth;
    }

    ngOnInit(): void {
        this.innerWidth = window.innerWidth;
        this.environment = _.cloneDeep(environment);
    }

    ngAfterViewInit() {
        this.innerWidth = window.innerWidth;
    }

    changeRFID() {
        this.showRFID = !this.showRFID;
    }
}
